// Formats: '%,n', '$,n', '$x,n', 'f,n', 'i,n'
// operations: 'last(a)', prod(a,b), ratio(a,b)
export default {
  social_video: {
    '***': [
      {
        metric: 100,
        inHeader: true,
        label: 'Ad Effect Score',
        rowType: 'demphasized',
        dataFormat: '.,0',
        reverseStat: false,
        minSampleSize: 0
      },
      {
        label: 'IN-MARKET PERFORMANCE',
        rowType: 'hb0'
      },
      {
        label: 'BREAKTHROUGH',
        rowType: 'h0'
      },
      {
        metric: 111,
        label: 'Branded Recall',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideZero: true
      },
      {
        label: 'IMPACT',
        rowType: 'h0'
      },
      {
        metric: 122,
        label: 'Lift to Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 121,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 123,
        label: 'Net Actions',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 124,
        label: 'Talk about the ad to friends or family',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 125,
        label: 'Go online for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 126,
        label: 'Follow brand/show/movie on social media',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 127,
        label: 'Watch any of the movies or TV shows featured',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 128,
        label: "Search for info about the shows/movies featured",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 129,
        label: "Subscribe to/Upgrade current service",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CREATIVE DIAGNOSTICS',
        rowType: 'hb0'
      },
      {
        label: 'BRANDING',
        rowType: 'h0'
      },
      {
        metric: 132,
        label: 'Ease of Branding',
        rowType: 'd0',
        dataFormat: '%,1',

        reverseStat: false
      },
      {
        metric: 133,
        label: 'Unique to this Brand',
        rowType: 'd0',
        dataFormat: '%,1',

        reverseStat: false
      },
      {
        metric: 237,
        label: 'Brand Recognition (at least one selected)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 238,
        label: 'All Bundle Brands Selected',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        label: 'Aided Branding (individual brands)',
        rowType: 'h0'
      },
      {
        metric: 239,
        label: 'Disney+',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        metric: 240,
        label: 'ESPN (streaming service)/ESPN+',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        metric: 244,
        label: 'Hulu',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        metric: 242,
        label: 'HBO Max',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        label: 'APPEAL',
        rowType: 'h0'
      },
      {
        metric: 151,
        label: 'Likes',
        rowType: 'd0',
        dataFormat: '%,1',

        reverseStat: false
      },
      {
        metric: 152,
        label: 'Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'CREATIVE EFFICIENCY',
        rowType: 'h0'
      },
      {
        metric: 1,
        label: 'Compelling Content',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 275,
        label: 'Piques my interest in new/different shows/movies',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 262,
        label: 'Sets the trends in entertainment',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 259,
        label: 'Good original movies & TV shows',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 260,
        label: 'Wide selection of movies & TV shows',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 261,
        label: 'Exclusive movies & TV shows',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 2,
        label: 'Brand Perceptions',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 256,
        label: 'High-quality entertainment service',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 143,
        label: 'Brand I can trust',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 254,
        label: 'Premium',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 252,
        label: 'Good value for the money',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 258,
        label: 'Brand/Service I can’t live without',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 253,
        label: 'Can replace cable/satellite',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 257,
        label: 'Mostly for kids',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },

      {
        metric: 220,
        label: 'Brand Relevance',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 142,
        label: 'Brand I want to be associated with',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 221,
        label: 'Spoke directly to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 211,
        label: 'Tells me something new about this brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 231,
        label: 'Relevant to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 223,
        label: 'Relatable people/situations',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 215,
        label: 'Makes me think of the brand in a new way',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 230,
        label: `Addresses issues important to me`,
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 270,
        label: 'Emotionally Engaging',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 222,
        label: 'Reassuring',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 271,
        label: 'Heartwarming',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 274,
        label: 'Worth seeing again',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 272,
        label: 'Clever',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 273,
        label: 'Unique',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 241,
        label: 'Entertaining',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 243,
        label: "Attention-grabbing",
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 263,
        label: "Humorous",
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 245,
        label: 'Annoying',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: true
      },
      {
        metric: 141,
        label: 'Brand Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 251,
        label: 'Brand/Service helps me have fun',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 255,
        label: 'Speaks to diversity/inclusivity in an authentic way',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 134,
        label: 'Good fit with brand',
        rowType: 'd0',
        dataFormat: '.,2',

        reverseStat: false
      },
      {
        metric: 212,
        label: 'Informative',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 210,
        label: 'Credible message coming from this brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 213,
        label: 'Clear',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 214,
        label: 'Presents information at a good pace',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 216,
        label: 'Confusing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: true
      },

      {
        label: 'CREATIVE EFFICIENCY - TOP TWO BOX',
        rowType: 'hb0'
      },
      {
        label: 'Compelling Content - T2B',
        rowType: 'h0'
      },
      {
        metric: 280,
        label: 'Piques my interest in new/different shows/movies - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 281,
        label: 'Sets the trends in entertainment - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 282,
        label: 'Good original movies & TV shows - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 283,
        label: 'Wide selection of movies & TV shows - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 284,
        label: 'Exclusive movies & TV shows - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'Brand Perceptions - T2B',
        rowType: 'h0'
      },
      {
        metric: 285,
        label: 'High-quality entertainment service - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 286,
        label: 'Brand I can trust - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 287,
        label: 'Premium - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 288,
        label: 'Good value for the money - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 289,
        label: 'Brand/Service I can’t live without - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 290,
        label: 'Can replace cable/satellite - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 291,
        label: 'Is mostly for kids - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'Brand Relevance - T2B',
        rowType: 'h0'
      },
      {
        metric: 292,
        label: 'Brand I want to be associated with - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 293,
        label: 'Spoke directly to me - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 294,
        label: 'Tells me something new about this brand - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 295,
        label: 'Relevant to me - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 296,
        label: 'Relatable people/situations - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 297,
        label: 'Makes me think of the brand in a new way - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 298,
        label: 'Addresses issues important to me - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'Emotionally Engaging - T2B',
        rowType: 'h0'
      },
      {
        metric: 299,
        label: 'Reassuring - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 300,
        label: 'Heartwarming - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 301,
        label: 'Worth seeing again - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 302,
        label: 'Clever - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 303,
        label: 'Unique - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 304,
        label: 'Entertaining - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 305,
        label: 'Attention-grabbing - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 306,
        label: 'Humorous - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 307,
        label: 'Annoying - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'Brand Connection - T2B',
        rowType: 'h0'
      },
      {
        metric: 308,
        label: 'Brand/Service helps me have fun - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 309,
        label: 'Speaks to diversity/inclusivity in an authentic way - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 310,
        label: 'Good fit with brand - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 311,
        label: 'Informative - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 312,
        label: 'Credible message coming from this brand - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 313,
        label: 'Clear - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 314,
        label: 'Presents information at a good pace - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 315,
        label: 'Confusing - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: '',
        rowType: 'eol'
      }
    ]
  },
  social_post: {
    '***': [
      {
        metric: 100,
        inHeader: true,
        label: 'Ad Effect Score',
        rowType: 'demphasized',
        dataFormat: '.,0',
        reverseStat: false,
        minSampleSize: 0
      },
      {
        label: 'IN-MARKET PERFORMANCE',
        rowType: 'hb0'
      },
      {
        label: 'BREAKTHROUGH',
        rowType: 'h0'
      },
      {
        metric: 111,
        label: 'Branded Recall',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideZero: true
      },
      {
        label: 'IMPACT',
        rowType: 'h0'
      },
      {
        metric: 122,
        label: 'Lift to Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 121,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 123,
        label: 'Net Actions',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 124,
        label: 'Talk about the ad to friends or family',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 125,
        label: 'Go online for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 126,
        label: 'Follow brand/show/movie on social media',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 127,
        label: 'Watch any of the movies or TV shows featured',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 128,
        label: "Search for info about the shows/movies featured",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 129,
        label: "Subscribe to/Upgrade current service",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CREATIVE DIAGNOSTICS',
        rowType: 'hb0'
      },
      {
        label: 'BRANDING',
        rowType: 'h0'
      },     
      {
        metric: 132,
        label: 'Ease of Branding',
        rowType: 'd0',
        dataFormat: '%,1',

        reverseStat: false
      },
      {
        metric: 133,
        label: 'Unique to this Brand',
        rowType: 'd0',
        dataFormat: '%,1',

        reverseStat: false
      },
      {
        metric: 237,
        label: 'Brand Recognition (at least one selected)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 238,
        label: 'All Bundle Brands Selected',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        label: 'Aided Branding (individual brands)',
        rowType: 'h0'
      },
      {
        metric: 239,
        label: 'Disney+',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        metric: 240,
        label: 'ESPN(streaming service)/ESPN+',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        metric: 244,
        label: 'Hulu',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        metric: 242,
        label: 'HBO Max',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        label: 'APPEAL',
        rowType: 'h0'
      },
      {
        metric: 151,
        label: 'Likes',
        rowType: 'd0',
        dataFormat: '%,1',

        reverseStat: false
      },
      {
        metric: 152,
        label: 'Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'CREATIVE EFFICIENCY',
        rowType: 'h0'
      },
      {
        metric: 1,
        label: 'Compelling Content',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 275,
        label: 'Piques my interest in new/different shows/movies',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 262,
        label: 'Sets the trends in entertainment',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 259,
        label: 'Good original movies & TV shows',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 260,
        label: 'Wide selection of movies & TV shows',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 261,
        label: 'Exclusive movies & TV shows',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 2,
        label: 'Brand Perceptions',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 256,
        label: 'High-quality entertainment service',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 143,
        label: 'Brand I can trust',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 254,
        label: 'Premium',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 252,
        label: 'Good value for the money',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 258,
        label: 'Brand/Service I can’t live without',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 253,
        label: 'Can replace cable/satellite',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 257,
        label: 'Mostly for kids',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },

      {
        metric: 220,
        label: 'Brand Relevance',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 142,
        label: 'Brand I want to be associated with',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 221,
        label: 'Spoke directly to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 211,
        label: 'Tells me something new about this brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 231,
        label: 'Relevant to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 223,
        label: 'Relatable people/situations',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 215,
        label: 'Makes me think of the brand in a new way',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 230,
        label: `Addresses issues important to me`,
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 270,
        label: 'Emotionally Engaging',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 222,
        label: 'Reassuring',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 271,
        label: 'Heartwarming',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 274,
        label: 'Worth seeing again',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 272,
        label: 'Clever',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 273,
        label: 'Unique',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 241,
        label: 'Entertaining',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 243,
        label: "Attention-grabbing",
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 263,
        label: "Humorous",
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 245,
        label: 'Annoying',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: true
      },
      {
        metric: 141,
        label: 'Brand Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 251,
        label: 'Brand/Service helps me have fun',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 255,
        label: 'Speaks to diversity/inclusivity in an authentic way',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 134,
        label: 'Good fit with brand',
        rowType: 'd0',
        dataFormat: '.,2',

        reverseStat: false
      },
      {
        metric: 212,
        label: 'Informative',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 210,
        label: 'Credible message coming from this brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 213,
        label: 'Clear',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 214,
        label: 'Presents information at a good pace',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 216,
        label: 'Confusing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: true
      },
      {
        label: 'CREATIVE EFFICIENCY - TOP TWO BOX',
        rowType: 'hb0'
      },
      {
        label: 'Compelling Content - T2B',
        rowType: 'h0'
      },
      {
        metric: 280,
        label: 'Piques my interest in new/different shows/movies - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 281,
        label: 'Sets the trends in entertainment - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 282,
        label: 'Good original movies & TV shows - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 283,
        label: 'Wide selection of movies & TV shows - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 284,
        label: 'Exclusive movies & TV shows - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'Brand Perceptions - T2B',
        rowType: 'h0'
      },
      {
        metric: 285,
        label: 'High-quality entertainment service - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 286,
        label: 'Brand I can trust - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 287,
        label: 'Premium - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 288,
        label: 'Good value for the money - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 289,
        label: 'Brand/Service I can’t live without - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 290,
        label: 'Can replace cable/satellite - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 291,
        label: 'Is mostly for kids - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'Brand Relevance - T2B',
        rowType: 'h0'
      },
      {
        metric: 292,
        label: 'Brand I want to be associated with - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 293,
        label: 'Spoke directly to me - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 294,
        label: 'Tells me something new about this brand - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 295,
        label: 'Relevant to me - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 296,
        label: 'Relatable people/situations - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 297,
        label: 'Makes me think of the brand in a new way - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 298,
        label: 'Addresses issues important to me - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'Emotionally Engaging - T2B',
        rowType: 'h0'
      },
      {
        metric: 299,
        label: 'Reassuring - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 300,
        label: 'Heartwarming - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 301,
        label: 'Worth seeing again - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 302,
        label: 'Clever - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 303,
        label: 'Unique - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 304,
        label: 'Entertaining - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 305,
        label: 'Attention-grabbing - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 306,
        label: 'Humorous - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 307,
        label: 'Annoying - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'Brand Connection - T2B',
        rowType: 'h0'
      },
      {
        metric: 308,
        label: 'Brand/Service helps me have fun - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 309,
        label: 'Speaks to diversity/inclusivity in an authentic way - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 310,
        label: 'Good fit with brand - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 311,
        label: 'Informative - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 312,
        label: 'Credible message coming from this brand - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 313,
        label: 'Clear - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 314,
        label: 'Presents information at a good pace - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 315,
        label: 'Confusing - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: '',
        rowType: 'eol'
      }
    ]
  },
  disney_radio: {
    '***': [
      {
        metric: 100,
        inHeader: true,
        label: 'Ad Effect Score',
        rowType: 'demphasized',
        dataFormat: '.,0',
        reverseStat: false,
        minSampleSize: 0
      },
      {
        label: 'IN-MARKET PERFORMANCE',
        rowType: 'hb0'
      },
      {
        label: 'BREAKTHROUGH',
        rowType: 'h0'
      },
      {
        metric: 111,
        label: 'Branded Recall',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideZero: true
      },
      {
        label: 'IMPACT',
        rowType: 'h0'
      },
      {
        metric: 122,
        label: 'Lift to Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 121,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 123,
        label: 'Net Actions',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 124,
        label: 'Talk about the ad to friends or family',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 125,
        label: 'Go online for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 126,
        label: 'Follow brand/show/movie on social media',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 127,
        label: 'Watch any of the movies or TV shows featured',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 128,
        label: "Search for info about the shows/movies featured",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 129,
        label: "Subscribe to/Upgrade current service",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CREATIVE DIAGNOSTICS',
        rowType: 'hb0'
      },
      {
        label: 'BRANDING',
        rowType: 'h0'
      },      
      {
        metric: 132,
        label: 'Ease of Branding',
        rowType: 'd0',
        dataFormat: '%,1',

        reverseStat: false
      },
      {
        metric: 133,
        label: 'Unique to this Brand',
        rowType: 'd0',
        dataFormat: '%,1',

        reverseStat: false
      },
      {
        metric: 237,
        label: 'Brand Recognition (at least one selected)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 238,
        label: 'All Bundle Brands Selected',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        label: 'Aided Branding (individual brands)',
        rowType: 'h0'
      },
      {
        metric: 239,
        label: 'Disney+',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        metric: 240,
        label: 'ESPN(streaming service)/ESPN+',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        metric: 244,
        label: 'Hulu',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        metric: 242,
        label: 'HBO Max',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        label: 'APPEAL',
        rowType: 'h0'
      },
      {
        metric: 151,
        label: 'Likes',
        rowType: 'd0',
        dataFormat: '%,1',

        reverseStat: false
      },
      {
        metric: 152,
        label: 'Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'CREATIVE EFFICIENCY',
        rowType: 'h0'
      },
      {
        metric: 1,
        label: 'Compelling Content',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 275,
        label: 'Piques my interest in new/different shows/movies',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 262,
        label: 'Sets the trends in entertainment',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 259,
        label: 'Good original movies & TV shows',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 260,
        label: 'Wide selection of movies & TV shows',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 261,
        label: 'Exclusive movies & TV shows',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 2,
        label: 'Brand Perceptions',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 256,
        label: 'High-quality entertainment service',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 143,
        label: 'Brand I can trust',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 254,
        label: 'Premium',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 252,
        label: 'Good value for the money',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 258,
        label: 'Brand/Service I can’t live without',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 253,
        label: 'Can replace cable/satellite',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 257,
        label: 'Mostly for kids',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },

      {
        metric: 220,
        label: 'Brand Relevance',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 142,
        label: 'Brand I want to be associated with',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 221,
        label: 'Spoke directly to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 211,
        label: 'Tells me something new about this brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 231,
        label: 'Relevant to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 223,
        label: 'Relatable people/situations',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 215,
        label: 'Makes me think of the brand in a new way',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 230,
        label: `Addresses issues important to me`,
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 270,
        label: 'Emotionally Engaging',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 222,
        label: 'Reassuring',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 271,
        label: 'Heartwarming',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 274,
        label: 'Worth seeing again',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 272,
        label: 'Clever',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 273,
        label: 'Unique',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 241,
        label: 'Entertaining',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 243,
        label: "Attention-grabbing",
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 263,
        label: "Humorous",
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 245,
        label: 'Annoying',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: true
      },
      {
        metric: 141,
        label: 'Brand Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 251,
        label: 'Brand/Service helps me have fun',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 255,
        label: 'Speaks to diversity/inclusivity in an authentic way',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 134,
        label: 'Good fit with brand',
        rowType: 'd0',
        dataFormat: '.,2',

        reverseStat: false
      },
      {
        metric: 212,
        label: 'Informative',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 210,
        label: 'Credible message coming from this brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 213,
        label: 'Clear',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 214,
        label: 'Presents information at a good pace',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 216,
        label: 'Confusing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: true
      },
      {
        label: 'CREATIVE EFFICIENCY - TOP TWO BOX',
        rowType: 'hb0'
      },
      {
        label: 'Compelling Content - T2B',
        rowType: 'h0'
      },
      {
        metric: 280,
        label: 'Piques my interest in new/different shows/movies - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 281,
        label: 'Sets the trends in entertainment - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 282,
        label: 'Good original movies & TV shows - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 283,
        label: 'Wide selection of movies & TV shows - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 284,
        label: 'Exclusive movies & TV shows - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'Brand Perceptions - T2B',
        rowType: 'h0'
      },
      {
        metric: 285,
        label: 'High-quality entertainment service - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 286,
        label: 'Brand I can trust - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 287,
        label: 'Premium - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 288,
        label: 'Good value for the money - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 289,
        label: 'Brand/Service I can’t live without - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 290,
        label: 'Can replace cable/satellite - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 291,
        label: 'Is mostly for kids - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'Brand Relevance - T2B',
        rowType: 'h0'
      },
      {
        metric: 292,
        label: 'Brand I want to be associated with - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 293,
        label: 'Spoke directly to me - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 294,
        label: 'Tells me something new about this brand - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 295,
        label: 'Relevant to me - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 296,
        label: 'Relatable people/situations - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 297,
        label: 'Makes me think of the brand in a new way - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 298,
        label: 'Addresses issues important to me - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'Emotionally Engaging - T2B',
        rowType: 'h0'
      },
      {
        metric: 299,
        label: 'Reassuring - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 300,
        label: 'Heartwarming - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 301,
        label: 'Worth seeing again - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 302,
        label: 'Clever - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 303,
        label: 'Unique - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 304,
        label: 'Entertaining - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 305,
        label: 'Attention-grabbing - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 306,
        label: 'Humorous - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 307,
        label: 'Annoying - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'Brand Connection - T2B',
        rowType: 'h0'
      },
      {
        metric: 308,
        label: 'Brand/Service helps me have fun - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 309,
        label: 'Speaks to diversity/inclusivity in an authentic way - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 310,
        label: 'Good fit with brand - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 311,
        label: 'Informative - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 312,
        label: 'Credible message coming from this brand - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 313,
        label: 'Clear - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 314,
        label: 'Presents information at a good pace - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 315,
        label: 'Confusing - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: '',
        rowType: 'eol'
      }
    ]
  },
  disney_ooh: {
    '***': [
      {
        metric: 100,
        inHeader: true,
        label: 'Ad Effect Score',
        rowType: 'demphasized',
        dataFormat: '.,0',
        reverseStat: false,
        minSampleSize: 0
      },
      {
        label: 'IN-MARKET PERFORMANCE',
        rowType: 'hb0'
      },
      {
        label: 'BREAKTHROUGH',
        rowType: 'h0'
      },
      {
        metric: 111,
        label: 'Branded Recall',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideZero: true
      },
      {
        label: 'IMPACT',
        rowType: 'h0'
      },
      {
        metric: 122,
        label: 'Lift to Impression',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 121,
        label: 'Lift to Consideration',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 123,
        label: 'Net Actions',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 124,
        label: 'Talk about the ad to friends or family',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 125,
        label: 'Go online for more information',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 126,
        label: 'Follow brand/show/movie on social media',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 127,
        label: 'Watch any of the movies or TV shows featured',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 128,
        label: "Search for info about the shows/movies featured",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 129,
        label: "Subscribe to/Upgrade current service",
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'CREATIVE DIAGNOSTICS',
        rowType: 'hb0'
      },
      {
        label: 'BRANDING',
        rowType: 'h0'
      },
      {
        metric: 132,
        label: 'Ease of Branding',
        rowType: 'd0',
        dataFormat: '%,1',

        reverseStat: false
      },
      {
        metric: 133,
        label: 'Unique to this Brand',
        rowType: 'd0',
        dataFormat: '%,1',

        reverseStat: false
      },
      {
        metric: 237,
        label: 'Brand Recognition (at least one selected)',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 238,
        label: 'All Bundle Brands Selected',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        label: 'Aided Branding (individual brands)',
        rowType: 'h0'
      },
      {
        metric: 239,
        label: 'Disney+',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        metric: 240,
        label: 'ESPN(streaming service)/ESPN+',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        metric: 244,
        label: 'Hulu',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        metric: 242,
        label: 'HBO Max',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false,
        hideNormHeader: true,
        colorHide: true
      },
      {
        label: 'APPEAL',
        rowType: 'h0'
      },
      {
        metric: 151,
        label: 'Likes',
        rowType: 'd0',
        dataFormat: '%,1',

        reverseStat: false
      },
      {
        metric: 152,
        label: 'Dislikes',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'CREATIVE EFFICIENCY',
        rowType: 'h0'
      },
      {
        metric: 1,
        label: 'Compelling Content',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 275,
        label: 'Piques my interest in new/different shows/movies',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 262,
        label: 'Sets the trends in entertainment',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 259,
        label: 'Good original movies & TV shows',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 260,
        label: 'Wide selection of movies & TV shows',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 261,
        label: 'Exclusive movies & TV shows',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 2,
        label: 'Brand Perceptions',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 256,
        label: 'High-quality entertainment service',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 143,
        label: 'Brand I can trust',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 254,
        label: 'Premium',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 252,
        label: 'Good value for the money',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 258,
        label: 'Brand/Service I can’t live without',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 253,
        label: 'Can replace cable/satellite',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 257,
        label: 'Mostly for kids',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },

      {
        metric: 220,
        label: 'Brand Relevance',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 142,
        label: 'Brand I want to be associated with',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 221,
        label: 'Spoke directly to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 211,
        label: 'Tells me something new about this brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 231,
        label: 'Relevant to me',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 223,
        label: 'Relatable people/situations',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 215,
        label: 'Makes me think of the brand in a new way',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 230,
        label: `Addresses issues important to me`,
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 270,
        label: 'Emotionally Engaging',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 222,
        label: 'Reassuring',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 271,
        label: 'Heartwarming',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 274,
        label: 'Worth seeing again',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 272,
        label: 'Clever',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 273,
        label: 'Unique',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 241,
        label: 'Entertaining',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 243,
        label: "Attention-grabbing",
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 263,
        label: "Humorous",
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 245,
        label: 'Annoying',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: true
      },
      {
        metric: 141,
        label: 'Brand Connection',
        rowType: 'dh0',
        dataFormat: 'idx',
        reverseStat: false
      },
      {
        metric: 251,
        label: 'Brand/Service helps me have fun',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 255,
        label: 'Speaks to diversity/inclusivity in an authentic way',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 134,
        label: 'Good fit with brand',
        rowType: 'd0',
        dataFormat: '.,2',

        reverseStat: false
      },
      {
        metric: 212,
        label: 'Informative',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 210,
        label: 'Credible message coming from this brand',
        rowType: 'd0',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 213,
        label: 'Clear',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 214,
        label: 'Presents information at a good pace',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: false
      },
      {
        metric: 216,
        label: 'Confusing',
        rowType: 'd0i',
        dataFormat: '.,2',
        reverseStat: true
      },
      {
        label: 'CREATIVE EFFICIENCY - TOP TWO BOX',
        rowType: 'hb0'
      },
      {
        label: 'Compelling Content - T2B',
        rowType: 'h0'
      },
      {
        metric: 280,
        label: 'Piques my interest in new/different shows/movies - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 281,
        label: 'Sets the trends in entertainment - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 282,
        label: 'Good original movies & TV shows - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 283,
        label: 'Wide selection of movies & TV shows - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 284,
        label: 'Exclusive movies & TV shows - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'Brand Perceptions - T2B',
        rowType: 'h0'
      },
      {
        metric: 285,
        label: 'High-quality entertainment service - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 286,
        label: 'Brand I can trust - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 287,
        label: 'Premium - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 288,
        label: 'Good value for the money - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 289,
        label: 'Brand/Service I can’t live without - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 290,
        label: 'Can replace cable/satellite - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 291,
        label: 'Is mostly for kids - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'Brand Relevance - T2B',
        rowType: 'h0'
      },
      {
        metric: 292,
        label: 'Brand I want to be associated with - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 293,
        label: 'Spoke directly to me - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 294,
        label: 'Tells me something new about this brand - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 295,
        label: 'Relevant to me - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 296,
        label: 'Relatable people/situations - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 297,
        label: 'Makes me think of the brand in a new way - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 298,
        label: 'Addresses issues important to me - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        label: 'Emotionally Engaging - T2B',
        rowType: 'h0'
      },
      {
        metric: 299,
        label: 'Reassuring - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 300,
        label: 'Heartwarming - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 301,
        label: 'Worth seeing again - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 302,
        label: 'Clever - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 303,
        label: 'Unique - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 304,
        label: 'Entertaining - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 305,
        label: 'Attention-grabbing - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 306,
        label: 'Humorous - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 307,
        label: 'Annoying - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: true
      },
      {
        label: 'Brand Connection - T2B',
        rowType: 'h0'
      },
      {
        metric: 308,
        label: 'Brand/Service helps me have fun - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 309,
        label: 'Speaks to diversity/inclusivity in an authentic way - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 310,
        label: 'Good fit with brand - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 311,
        label: 'Informative - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 312,
        label: 'Credible message coming from this brand - T2B',
        rowType: 'd0',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 313,
        label: 'Clear - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 314,
        label: 'Presents information at a good pace - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: false
      },
      {
        metric: 315,
        label: 'Confusing - T2B',
        rowType: 'd0i',
        dataFormat: '%,1',
        reverseStat: true
      },

      {
        label: '',
        rowType: 'eol'
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/app/configuration/DisneyHulu/config/components/scorecard/MetricsLabels/metricsLabels.js